import {type ActionState, type CardEnum} from '@colonist/game-states'

export interface DicePair {
    dice1: number
    dice2: number
}

export interface SelectDiceFormat {
    developmentCardUsed: CardEnum
    allowableActionState: ActionState
    cancelButtonActive: boolean
}

export enum EventDiceEnum {
    Science = 4,
    Trade = 5,
    Politics = 6,
}
